import { baseEntityReducers, baseInitialState } from './base/baseModelStore';
import { ChamberInstallationInfo as SiteInfo } from '@api-model/models';
import { AppThunk } from '@root/store/store';
import { ModelReducers } from './modelReducers';
import { createSlice } from '@reduxjs/toolkit';
import { httpClient } from '@infrastructure/http/HttpClient';
import { dispatchAdditionalActions, AdditionalAction } from './base/baseModelThunks';

const slice = createSlice({
  name: ModelReducers.siteInstallationInfo,
  initialState: baseInitialState<SiteInfo>(),
  reducers: {
    ...baseEntityReducers((site) => (site as SiteInfo).id.toString()),
  },
});

const getEntity = (
  siteId: string,
  additionalActions?: ((response: SiteInfo) => AdditionalAction)[]
): AppThunk => async (dispatch) => {
  const actions = slice.actions;
  try {
    dispatch(actions.startLoading());
    const { data } = await httpClient.get<SiteInfo>(`chambers/${siteId}/install`);

    dispatch(actions.getEntitySuccess(data));

    if (additionalActions) dispatchAdditionalActions(dispatch, additionalActions, data);
  } catch (err) {
    dispatch(actions.loadingFailed(err.toString()));
  }
};

const thunks = {
  fetchEntity: getEntity,
};

export const siteInstallationInfoEntity = {
  reducer: slice.reducer,
  actions: slice.actions,
  thunks,
} as {
  reducer: typeof slice.reducer;
  actions: typeof slice.actions;
  thunks: typeof thunks;
};
